import React from "react"

export default function TransitionTitle({title}) {
  return (
    <div className='page--title flex'>
      <div className='ma title-wrapper'>
        <p className='title h1 unica'></p>
      </div>
    </div>
  )
}
